import { useEchoStore } from '@/context/EchoContext';

/**
 * Merges system-defined Echoes with user's own created Echoes.
 * Returns a unified contacts map keyed by echo ID/key.
 */
export const useEchoContacts = () => {
  const { allContactEchoes, isLoading } = useEchoStore();
  return { echoes: allContactEchoes, isLoading };
};
